/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 *
 * Babel does not include DOM polyfills
 * these methods are particularly useful in delegated event handlers
 * which are a common and sound pattern in React
 *
 */

var polyfillMatches = function polyfillMatches() {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
};
var polyfillClosest = function polyfillClosest() {
  polyfillMatches();
  if (!Element.prototype.closest) {
    Element.prototype.closest = function closest(s) {
      var el = this;
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
};

export { polyfillClosest, polyfillMatches };
